export default "__VITE_ASSET__J1cxM1uD__"